import { Link } from 'react-router-dom';

const Footer = () => {
    const currentYear = new Date().getFullYear();

    const footerLinks = {
        company: [
            { label: "Home", href: "https://www.wellcraftedtech.com/", external: true },
            { label: "Services", href: "https://www.wellcraftedtech.com/#services", external: true },
            { label: "FAQ", href: "https://www.wellcraftedtech.com/#faq", external: true },
            { label: "Testimonials", href: "https://www.wellcraftedtech.com/#testimonials", external: true }
        ],
        support: [
            { label: "About Us", href: "https://www.wellcraftedtech.com/", external: true },
            { label: "Contact Us", href: "https://www.wellcraftedtech.com/#contact", external: true },
            { label: "Privacy & Policy", href: "/privacy-policy", external: false },
            { label: "Terms of Service", href: "/terms-of-service", external: false }
        ]
    };

    const socialLinks = [
      {
        name: 'X (Twitter)',
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-5 h-5"
          >
            <path d="M18.244 2H21.82L14.01 10.94L23.19 22H15.99L10.35 15.31L4.45 22H0.87L9.2 12.47L0.38 2H7.76L12.85 8.11L18.244 2ZM16.98 19.91H18.98L6.67 4H4.52L16.98 19.91Z" />
          </svg>
        ),
        href: 'https://x.com/WellcraftedTech',
      },
      {
        name: 'LinkedIn',
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
          </svg>
        ),
        href: 'https://www.linkedin.com/company/wellcrafted-technologies',
      },
      {
        name: 'Instagram',
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z" />
          </svg>
        ),
        href: 'https://www.instagram.com/wellcraftedtech',
      },
      {
        name: 'Whatsapp Community',
        icon: (
          <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12.004 2.003c-5.523 0-9.998 4.475-9.998 9.998 0 1.762.46 3.482 1.334 5.002L2 22l5.13-1.309a9.955 9.955 0 004.874 1.247h.004c5.523 0 9.998-4.475 9.998-9.998S17.531 2.003 12.004 2.003zm0 18.182a8.16 8.16 0 01-4.162-1.147l-.297-.177-3.045.777.813-2.969-.193-.305a8.164 8.164 0 01-1.25-4.363c0-4.513 3.67-8.183 8.183-8.183s8.183 3.67 8.183 8.183-3.67 8.183-8.183 8.183zm4.506-6.145c-.247-.124-1.46-.721-1.687-.803-.227-.082-.392-.124-.557.124-.165.247-.64.803-.784.969-.144.165-.289.186-.536.062-.247-.124-1.043-.384-1.986-1.224-.733-.653-1.228-1.46-1.372-1.707-.144-.247-.015-.381.109-.505.111-.11.247-.289.371-.433.124-.144.165-.247.247-.412.082-.165.041-.309-.02-.433-.062-.124-.557-1.344-.763-1.84-.201-.482-.405-.417-.557-.425l-.475-.008c-.165 0-.433.062-.66.309-.227.247-.866.846-.866 2.062 0 1.216.887 2.392 1.01 2.557.124.165 1.744 2.664 4.226 3.736.591.255 1.052.407 1.411.521.593.189 1.133.162 1.56.098.476-.071 1.46-.597 1.667-1.173.206-.577.206-1.071.144-1.173-.062-.103-.227-.165-.474-.289z" />
          </svg>
        ),
        href: 'https://chat.whatsapp.com/Gg3GmMw1pof7efNPis8zkl',
      },
    ];

    return (
        <footer className="relative z-10 bg-gradient-to-b from-[#8E57FA]/20 to-[#6B3FD9]/10 border-t border-[#FFFFFF1A]">
            <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-20 py-12 sm:py-16 md:py-20">
                {/* Main Footer Content */}
                <div className="flex flex-col md:flex-row justify-between gap-8 md:gap-12 lg:gap-16 mb-8 md:mb-12">
                    {/* Brand Section */}
                    <div className="space-y-4 sm:space-y-6 text-center md:text-left">
                        {/* Logo */}
                        <div className="flex items-center justify-center md:justify-start gap-3">
                            <div className="bg-[#8E57FA] rounded-[8px] shrink-0">
                                <img
                                    src="/heroSection/NavbarLogo-256.png"
                                    alt="Eddy AI Logo"
                                    width={44}
                                    height={44}
                                    decoding="async"
                                    className="h-[32px] md:h-[38px] lg:h-[44px] w-auto"
                                />
                            </div>
                            <span
                                className="text-[#8E57FA]"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 700,
                                    fontSize: "clamp(20px, 4vw, 24px)",
                                }}
                            >
                                Eddy AI
                            </span>
                        </div>

                        {/* Description */}
                        <p
                            className="text-[#DCCBFD] max-w-[350px] mx-auto md:mx-0"
                            style={{
                                fontFamily: "'Roboto', sans-serif",
                                fontWeight: 400,
                                fontSize: "clamp(14px, 3vw, 16px)",
                                lineHeight: "clamp(24px, 5vw, 24px)",
                                letterSpacing: "0px",
                            }}
                        >
                            A learning platform helping students worldwide achieve their academic goals through personalized education.
                        </p>

                        {/* Social Links */}
                        <div className="flex gap-3 justify-center md:justify-start">
                            {socialLinks.map((social) => (
                                <a
                                    key={social.name}
                                    href={social.href}
                                    className="w-10 h-10 rounded-[10px] bg-[#6B41BC]  text-white flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95"
                                    aria-label={social.name}
                                >
                                    {social.icon}
                                </a>
                            ))}
                        </div>
                    </div>
                    {/* Company and Support Links */}
                    <div className="grid grid-cols-2 md:flex md:flex-row md:justify-evenly md:items-start gap-6 md:gap-12 lg:gap-24 w-full md:w-auto">
                        {/* Company Links */}
                        <div className="text-left">
                            <h3
                                className="text-white mb-3 sm:mb-4 md:mb-6"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 600,
                                    fontSize: "clamp(15px, 3.5vw, 18px)",
                                }}
                            >
                                Company
                            </h3>
                            <ul className="space-y-2.5 sm:space-y-3">
                                {footerLinks.company.map((link) => (
                                    <li key={link.label}>
                                        <a
                                            href={link.href}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="text-[#DCCBFD] hover:text-white transition-colors duration-200"
                                            style={{
                                                fontFamily: "'Roboto', sans-serif",
                                                fontWeight: 400,
                                                fontSize: "clamp(13px, 2.8vw, 14px)",
                                            }}
                                        >
                                            {link.label}
                                        </a>
                                    </li>
                                ))}
                            </ul>
                        </div>

                        {/* Support Links */}
                        <div className="text-left">
                            <h3
                                className="text-white mb-3 sm:mb-4 md:mb-6"
                                style={{
                                    fontFamily: "'Poppins', sans-serif",
                                    fontWeight: 600,
                                    fontSize: "clamp(15px, 3.5vw, 18px)",
                                }}
                            >
                                Support
                            </h3>
                            <ul className="space-y-2.5 sm:space-y-3">
                                {footerLinks.support.map((link) => (
                                    <li key={link.label}>
                                        {link.external ? (
                                            <a
                                                href={link.href}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="text-[#DCCBFD] hover:text-white transition-colors duration-200"
                                                style={{
                                                    fontFamily: "'Roboto', sans-serif",
                                                    fontWeight: 400,
                                                    fontSize: "clamp(13px, 2.8vw, 14px)",
                                                }}
                                            >
                                                {link.label}
                                            </a>
                                        ) : (
                                            <Link
                                                to={link.href}
                                                className="text-[#DCCBFD] hover:text-white transition-colors duration-200"
                                                style={{
                                                    fontFamily: "'Roboto', sans-serif",
                                                    fontWeight: 400,
                                                    fontSize: "clamp(13px, 2.8vw, 14px)",
                                                }}
                                            >
                                                {link.label}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>

                </div>

                {/* Bottom Bar */}
                <div className="pt-8 border-t border-[#FFFFFF1A] flex flex-col sm:flex-row items-center justify-between gap-4">
                    {/* Copyright */}
                    <p
                        className="text-[#ffff] text-center sm:text-left"
                        style={{
                            fontFamily: "'Roboto', sans-serif",
                            fontWeight: 400,
                            fontSize: "clamp(12px, 2.5vw, 13px)",
                        }}
                    >
                        © {currentYear} Eddy AI. All rights reserved.
                    </p>

                    {/* Powered By */}
                    <div className="flex items-center justify-center cursor-pointer">
                        <a href="https://www.wellcraftedtech.com/">
                            <img src="/PowerBy.svg" alt="Powered by WellCrafted" className="max-w-[150px] sm:max-w-[202px] h-auto" />
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
